import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import FaInfoCircle from 'react-icons/lib/fa/info-circle';
import Tooltip from 'react-tt';

import {
    generateIsomorphicID,
} from 'wanderu-utils';

import styles from './ContextHelp.scss';
import variables from 'wanderu-css/variables.scss';
const {
    tooltipZIndex,
    tooltipSpacing,
} = variables;

function ContextHelp(props) {
    const {
        className,
        message,
        position,
    } = props;
    const tooltipUUID = generateIsomorphicID(props);

    return (
        <div className={classNames(
            styles.container,
            className,
        )}>
            <FaInfoCircle
                data-for={tooltipUUID}
                data-tip="tooltip"
            />
            <Tooltip
                id={tooltipUUID}
                location={position}
                spacing={parseInt(tooltipSpacing, 10)}
                zIndex={parseInt(tooltipZIndex, 10)}
            >
                <div className={styles.tooltipContent}>
                    {message}
                </div>
            </Tooltip>
        </div>
    );
}

ContextHelp.propTypes = {
    className: PropTypes.string,
    message: PropTypes.string.isRequired,
    position: PropTypes.oneOf([
        'top',
        'left',
        'right',
        'bottom',
    ]),
};

ContextHelp.defaultProps = {
    className: '',
    message: '',
    position: 'top',
};

export default ContextHelp;
